module.exports = __webpack_public_path__ + "img/i_ar_nxt_m_w.fb79abb2.svg";